<template>
  <section>
    <title>Dashboard | Automod Filters</title>
    <div class="page-loader" v-if="!loaded"><div class="page-pulse"><div></div><div></div><div></div></div></div>
    <div class="state-bar" v-if="loaded">
      <a href="/dashboard">Go To The Server Selection Menu</a>
   </div>
    <form class="form" v-if="loaded">
      <div class="form-field">
        <p class="form-field-title">Anti-Spam</p>
        <p class="form-field-title-description">Filters out repeated message or messages sent at small intervals.</p>
        <v-select class="automod-type" :options="selectOptions" @input="update('spam-opt')" v-model="spamOpt"></v-select>
        <input type="number" min="0" @input="update('spam-int')" v-model="spamStrikes" class="form-field-text-input automod-strikes" placeholder="Amount of strikes">
      </div>
      <div class="form-field">
        <p class="form-field-title">Anti-Phishing & Dangerous Links</p>
        <p class="form-field-title-description">Filters out all messages that contain dangerous or malicious links, such as IP loggers, phishing websites, and more.</p>
        <v-select class="automod-type" :options="selectOptions" @input="update('refferal-opt')" v-model="refferalOpt"></v-select>
        <input type="number" min="0" @input="update('refferal-int')" v-model="refferalStrikes" class="form-field-text-input automod-strikes" placeholder="Amount of strikes">
      </div>
      <div class="form-field">
        <p class="form-field-title">Anti-Links</p>
        <p class="form-field-title-description">Filters out *all* links sent by non-moderators and above.</p>
        <v-select class="automod-type" :options="selectOptions" @input="update('link-opt')" v-model="linkOpt"></v-select>
        <input type="number" min="0" @input="update('link-int')" v-model="linkStrikes" class="form-field-text-input automod-strikes" placeholder="Amount of strikes">
      </div>
      <div class="form-field">
        <p class="form-field-title">Anti-Copypastas</p>
        <p class="form-field-title-description">Filters out messages containing copypastas.</p>
        <v-select class="automod-type" :options="selectOptions" @input="update('copypastas-opt')" v-model="copypastasOpt"></v-select>
        <input type="number" min="0" @input="update('copypastas-int')" v-model="copypastasStrikes" class="form-field-text-input automod-strikes" placeholder="Amount of strikes">
      </div>
      <div class="form-field">
        <p class="form-field-title">Anti-Invites</p>
        <p class="form-field-title-description">Filters out messages containing discord invite links.</p>
        <v-select class="automod-type" :options="selectOptions" @input="update('invites-opt')" v-model="invitesOpt"></v-select>
        <input type="number" min="0" @input="update('invites-int')" v-model="invitesStrikes" class="form-field-text-input automod-strikes" placeholder="Amount of strikes">
      </div>
      <div class="form-field">
        <p class="form-field-title">Anti-@Everyone/@Here</p>
        <p class="form-field-title-description">Strikes people who attempts to mention everyone/here without having discord permission to.</p>
        <v-select class="automod-type" :options="selectOptions" @input="update('everyone-opt')" v-model="everyoneOpt"></v-select>
        <input type="number" min="0" @input="update('everyone-int')" v-model="everyoneStrikes" class="form-field-text-input automod-strikes" placeholder="Amount of strikes">
      </div>
      <div class="form-field">
        <p class="form-field-title">Max Lines</p>
        <p class="form-field-title-description">Allows you to set up a limit on how many lines a message can have.</p>
        <v-select class="automod-type" :options="selectOptions" @input="update('max-lines-opt')" v-model="linesOpt"></v-select>
        <input type="number" min="2" @input="update('max-lines-amount')" v-model="linesAmount" class="form-field-text-input automod-strikes-second" placeholder="Amount of lines">
        <input type="number" min="0" @input="update('max-lines-int')" v-model="linesStrikes" class="form-field-text-input automod-strikes-third" placeholder="Amount of strikes">
      </div>
      <div class="form-field">
        <p class="form-field-title">Max Mentions</p>
        <p class="form-field-title-description">Allows you to set up a limit on how many mentions a message can have.</p>
        <v-select class="automod-type" :options="selectOptions" @input="update('max-mentions-opt')" v-model="mentionsOpt"></v-select>
        <input type="number" min="2" @input="update('max-mentions-amount')" v-model="mentionsAmount" class="form-field-text-input automod-strikes-second" placeholder="Amount of mentions">
        <input type="number" min="0" @input="update('max-mentions-int')" v-model="mentionsStrikes" class="form-field-text-input automod-strikes-third" placeholder="Amount of strikes">
      </div>
      <div class="form-field">
        <p class="form-field-title">Excessive Caps</p>
        <p class="form-field-title-description">Prevent messages from having capital letters in proportions of (>70%) or more if the message has more than 5 characters chars.</p>
        <v-select class="automod-type" :options="selectOptions" @input="update('caps-opt')" v-model="capsOpt"></v-select>
        <input type="number" min="0" @input="update('caps-int')" v-model="capsStrikes" class="form-field-text-input automod-strikes" placeholder="Amount of strikes">
      </div>
      <div class="form-field">
        <p class="form-field-title">Excessive Spoilers</p>
        <p class="form-field-title-description">Prevents messages from sending multiple spoilers in a certain amount of time.</p>
        <v-select class="automod-type" :options="selectOptions" @input="update('spoilers-opt')" v-model="spoilersOpt"></v-select>
        <input type="number" min="0" @input="update('spoilers-int')" v-model="spoilersStrikes" class="form-field-text-input automod-strikes" placeholder="Amount of strikes">
      </div>
      <div class="form-field">
        <p class="form-field-title">Excessive Images</p>
        <p class="form-field-title-description">Prevents messages from sending multiple attachments in a certain amount of time.</p>
        <v-select class="automod-type" :options="selectOptions" @input="update('images-opt')" v-model="imagesOpt"></v-select>
        <input type="number" min="0" @input="update('images-int')" v-model="imagesStrikes" class="form-field-text-input automod-strikes" placeholder="Amount of strikes">
      </div>
      <div class="form-field">
        <p class="form-field-title">Excessive Emojis</p>
        <p class="form-field-title-description">Prevents users from sending excessive emojis.</p>
        <v-select class="automod-type" :options="selectOptions" @input="update('emojis-opt')" v-model="emojisOpt"></v-select>
        <input type="number" min="0" @input="update('emojis-int')" v-model="emojisStrikes" class="form-field-text-input automod-strikes" placeholder="Amount of strikes">
      </div>
      <div class="form-field">
        <p class="form-field-title">Auto Dehoisting</p>
        <p class="form-field-title-description">This will dehoist members automatically.</p>
        <v-select :options="toggleOptions" @input="update('dehoist-opt')" v-model="dehoistOpt"></v-select>
      </div>
      <div class="form-field">
        <p class="form-field-title">Minimum Account Age</p>
        <p class="form-field-title-description">This will require new users joining the server to have this minimum age on their account.</p>
        <input class="automod-type form-field-text-input " type="number" min="0" @input="update('age-int')" v-model="ageStrikes" placeholder="Amount of strikes">
        <v-select class="automod-strikes" :options="timeOptions" @input="update('age-opt')" v-model="ageOpt"></v-select>
      </div>
      <div class="form-field">
        <p class="form-field-title">Ignored Roles</p>
        <p class="form-field-title-description">Role that will be ignored by auto moderator. (If user has any of these he'll be ignored by automod in chat.)</p>
        <v-select :options="arraify(cache.roles).map(role => ({ label: `@ ${role.name}`, value: role.id }))" @input="update('role-opt')" v-model="roleOpt" multiple></v-select>
      </div>
      <div class="form-field">
        <p class="form-field-title">Ignored Channels</p>
        <p class="form-field-title-description">Channels that will be ignored by auto moderator.</p>
        <v-select :options="textChannels.map(channel => ({ label: `# ${channel.name}`, value: channel.id }))" @input="update('channel-opt')" v-model="channelOpt" multiple></v-select>
      </div>
    </form>
  </section>
</template>

<script>
export default {
  name: "Automod",
  watch: {
    confirm (value) {
      this.$emit("setPromptVisibility", value);
    },
    saving (value) {
      this.$emit("setPromptLoading", value);
    }
  },
  data () {
    return {
      loaded: false,
      settings: {},
      cache: {},
      changes: {},
      upgrade: 0,
      confirm: false,
      saving: false,
      selectOptions: [
        {
          label: "Disabled",
          value: "disabled"
        },
        {
          label: "Strike",
          value: "strike"
        },
        {
          label: "Delete Message",
          value: "delete"
        },
        {
          label: "Delete Message & Strike",
          value: "delete-strike"
        }
      ],
      spamOpt: null,
      spamType: null,
      spamStrikes: null,
      linkOpt: null,
      linkType: null,
      linkStrikes: null,
      refferalOpt: null,
      refferalType: null,
      refferalStrikes: null,
      copypastasOpt: null,
      copypastasType: null,
      copypastasStrikes: null,
      invitesOpt: null,
      invitesType: null,
      invitesStrikes: null,
      everyoneOpt: null,
      everyoneType: null,
      everyoneStrikes: null,
      linesOpt: null,
      linesType: null,
      linesAmount: null,
      linesStrikes: null,
      mentionsOpt: null,
      mentionsType: null,
      mentionsAmount: null,
      mentionsStrikes: null,
      capsOpt: null,
      capsType: null,
      capsStrikes: null,
      spoilersOpt: null,
      spoilersType: null,
      spoilersStrikes: null,
      imagesOpt: null,
      imagesType: null,
      imagesStrikes: null,
      emojisOpt: null,
      emojisType: null,
      emojisStrikes: null,
      dehoistOpt: null,
      dehoistType: null,
      toggleOptions: [
        {
          label: "Disabled",
          value: "disabled"
        },
        {
          label: "Enabled",
          value: "enabled"
        }
      ],
      timeOptions: [
        {
          label: "Minutes",
          value: "m"
        },
        {
          label: "Hours",
          value: "h"
        },
        {
          label: "Days",
          value: "d"
        },
        {
          label: "Weeks",
          value: "w"
        },
        {
          label: "Years",
          value: "y"
        }
      ],
      ageOpt: null,
      ageType: null,
      ageStrikes: null,
      roleOpt: null,
      roleType: null,
      textChannels: null,
      channelOpt: null,
      channelType: null
    };
  },
  methods: {
    fetchGuildData: async function () {
      const response = await this.$axios.get(`${this.$apiBase}/v1/information/${this.$route.params.id}/cache`, {
        withCredentials: true,
        credentials: "same-origin"
      });
      this.cache = response.data.data;

      const settingsResponse = await this.$axios.get(`${this.$apiBase}/v1/information/${this.$route.params.id}/settings`, {
        withCredentials: true,
        credentials: "same-origin"
      });

      this.settings = settingsResponse.data.data;
      this.loaded = true;

      this.init();
    },
    init: function () {
      const GuildTextType = 0;
      this.textChannels = this.arraify(this.cache.channels).filter(c => c.type === GuildTextType);
      /* Spam Field */
      this.spamOpt = this.selectOptions.find(opt => opt.value === this.settings.automod_spam_type);
      this.spamType = this.settings.automod_spam_type;
      this.spamStrikes = this.settings.automod_spam;
      /* Link Field */
      this.linkOpt = this.selectOptions.find(opt => opt.value === this.settings.automod_links_type);
      this.linkType = this.settings.automod_links_type;
      this.linkStrikes = this.settings.automod_links;
      /* Refferal Field */
      this.refferalOpt = this.selectOptions.find(opt => opt.value === this.settings.automod_referral_type);
      this.refferalType = this.settings.automod_referral_type;
      this.refferalStrikes = this.settings.automod_referral;
      /* Copypastas Field */
      this.copypastasOpt = this.selectOptions.find(opt => opt.value === this.settings.automod_copypastas_type);
      this.copypastasType = this.settings.automod_copypastas_type;
      this.copypastasStrikes = this.settings.automod_copypastas;
      /* Invites Field */
      this.invitesOpt = this.selectOptions.find(opt => opt.value === this.settings.automod_invites_type);
      this.invitesType = this.settings.automod_invites_type;
      this.invitesStrikes = this.settings.automod_invites;
      /* Everyone Field */
      this.everyoneOpt = this.selectOptions.find(opt => opt.value === this.settings.automod_everyone_type);
      this.everyoneType = this.settings.automod_everyone_type;
      this.everyoneStrikes = this.settings.automod_everyone;
      /* MaxLines Field */
      this.linesOpt = this.selectOptions.find(opt => opt.value === this.settings.automod_max_lines_type);
      this.linesType = this.settings.automod_max_lines_type;
      this.linesStrikes = this.settings.automod_max_lines;
      this.linesAmount = this.settings.automod_max_lines_amount;
      /* MaxMentions Field */
      this.mentionsOpt = this.selectOptions.find(opt => opt.value === this.settings.automod_max_mentions_type);
      this.mentionsType = this.settings.automod_max_mentions_type;
      this.mentionsStrikes = this.settings.automod_max_mentions;
      this.mentionsAmount = this.settings.automod_max_mentions_amount;
      /* Caps Field */
      this.capsOpt = this.selectOptions.find(opt => opt.value === this.settings.automod_caps_type);
      this.capsType = this.settings.automod_caps_type;
      this.capsStrikes = this.settings.automod_caps;
      /* Spoilers Field */
      this.spoilersOpt = this.selectOptions.find(opt => opt.value === this.settings.automod_spoilers_type);
      this.spoilersType = this.settings.automod_spoilers_type;
      this.spoilersStrikes = this.settings.automod_spoilers;
      /* Images Field */
      this.imagesOpt = this.selectOptions.find(opt => opt.value === this.settings.automod_images_type);
      this.imagesType = this.settings.automod_images_type;
      this.imagesStrikes = this.settings.automod_images;
      /* Emojis Field */
      this.emojisOpt = this.selectOptions.find(opt => opt.value === this.settings.automod_emojis_type);
      this.emojisType = this.settings.automod_emojis_type;
      this.emojisStrikes = this.settings.automod_emojis;
      /* Dehoist Field */
      this.dehoistOpt = this.toggleOptions.find(opt => opt.value === this.settings.automod_dehoist);
      this.dehoistType = this.settings.automod_dehoist;
      /* Age Limit Field */
      this.ageOpt = this.timeOptions.find(opt => opt.value === this.settings.automod_age_type);
      this.ageType = this.settings.automod_age_type;
      this.ageStrikes = this.settings.automod_age_amount;
      /* Ignored Roles Field */
      this.roleOpt = this.arraify(this.cache.roles).filter(r => this.settings.ignored_roles.includes(r.id)).map(item => ({
        label: `@ ${item.name}`,
        value: item.id
      }));
      this.roleType = this.settings.ignored_roles;
      /* Ignored Channels Field */
      this.channelOpt = this.textChannels.filter(c => this.settings.ignored_channels.includes(c.id)).map(item => ({
        label: `# ${item.name}`,
        value: item.id
      }));
      this.channelType = this.settings.ignored_channels;
    },
    arraify: function (object) {
      var output = [];
      for (const key of Object.keys(object)) {
        output.push(object[key]);
      }
      return output;
    },
    save: async function () {
      this.saving = true;

      await this.$axios.post(`${this.$apiBase}/v1/settings/${this.settings.id}/automod`, {
        "automod-spam": this.spamStrikes,
        "anti-spam-type": this.spamType,
        "automod-links": this.linkStrikes,
        "anti-links-type": this.linkType,
        "automod-referral": this.refferalStrikes,
        "anti-referral-type": this.refferalType,
        "automod-copypastas": this.copypastasStrikes,
        "anti-copypastas-type": this.copypastasType,
        "automod-invites": this.invitesStrikes,
        "anti-invites-type": this.invitesType,
        "automod-everyone": this.everyoneStrikes,
        "anti-everyone-type": this.everyoneType,
        "max-lines-type": this.linesType,
        "automod-max-lines-amount": this.linesAmount,
        "automod-max-lines": this.linesStrikes,
        "max-mentions-type": this.mentionsType,
        "automod-max-mentions-amount": this.mentionsAmount,
        "automod-max-mentions": this.mentionsStrikes,
        "automod-caps": this.capsStrikes,
        "anti-caps-type": this.capsType,
        "automod-spoilers": this.spoilersStrikes,
        "anti-spoilers-type": this.spoilersType,
        "automod-images": this.imagesStrikes,
        "anti-images-type": this.imagesType,
        "automod-emojis": this.emojisStrikes,
        "anti-emojis-type": this.emojisType,
        "automod-dehoist": this.dehoistType,
        "automod-age-amount": this.ageStrikes,
        "automod-age-type": this.ageType,
        "ignored-roles": JSON.stringify(this.roleType),
        "ignored-channels": JSON.stringify(this.channelType)
      }, {
        withCredentials: true,
        credentials: "same-origin"
      });
      await this.fetchGuildData();
      this.changes = {};
      this.saving = false;
      this.updateBar();
    },
    update: async function (field) {
      switch(field) {
        case "spam-opt":
          this.spamType = this.spamOpt ? this.spamOpt.value : "disabled";
          if (this.spamType !== this.settings.automod_spam_type) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "spam-int":
          this.spamStrikes = this.spamStrikes && parseInt(this.spamStrikes) ? parseInt(this.spamStrikes) : null;
          if (this.spamStrikes !== this.settings.automod_spam) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "link-opt":
          this.linkType = this.linkOpt ? this.linkOpt.value : "disabled";
          if (this.linkType !== this.settings.automod_links_type) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "link-int":
          this.linkStrikes = this.linkStrikes && parseInt(this.linkStrikes) ? parseInt(this.linkStrikes) : null;
          if (this.linkStrikes !== this.settings.automod_links) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "refferal-opt":
          this.refferalType = this.refferalOpt ? this.refferalOpt.value : "disabled";
          if (this.refferalType !== this.settings.automod_referral_type) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "refferal-int":
          this.refferalStrikes = this.refferalStrikes && parseInt(this.refferalStrikes) ? parseInt(this.refferalStrikes) : null;
          if (this.refferalStrikes !== this.settings.automod_referral) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "copypastas-opt":
          this.copypastasType = this.copypastasOpt ? this.copypastasOpt.value : "disabled";
          if (this.copypastasType !== this.settings.automod_copypastas_type) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "copypastas-int":
          this.copypastasStrikes = this.copypastasStrikes && parseInt(this.copypastasStrikes) ? parseInt(this.copypastasStrikes) : null;
          if (this.copypastasStrikes !== this.settings.automod_copypastas) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "invites-opt":
          this.invitesType = this.invitesOpt ? this.invitesOpt.value : "disabled";
          if (this.invitesType !== this.settings.automod_invites_type) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "invites-int":
          this.invitesStrikes = this.invitesStrikes && parseInt(this.invitesStrikes) ? parseInt(this.invitesStrikes) : null;
          if (this.invitesStrikes !== this.settings.automod_invites) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "everyone-opt":
          this.everyoneType = this.everyoneOpt ? this.everyoneOpt.value : "disabled";
          if (this.everyoneType !== this.settings.automod_everyone_type) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "everyone-int":
          this.everyoneStrikes = this.everyoneStrikes && parseInt(this.everyoneStrikes) ? parseInt(this.everyoneStrikes) : null;
          if (this.everyoneStrikes !== this.settings.automod_everyone) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "max-lines-opt":
          this.linesType = this.linesOpt ? this.linesOpt.value : "disabled";
          if (this.linesType !== this.settings.automod_max_lines_type) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "max-lines-int":
          this.linesStrikes = this.linesStrikes && parseInt(this.linesStrikes) ? parseInt(this.linesStrikes) : null;
          if (this.linesStrikes !== this.settings.automod_max_lines) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "max-lines-amount":
          this.linesAmount = this.linesAmount && parseInt(this.linesAmount) ? parseInt(this.linesAmount) : 2;
          if (this.linesAmount !== this.settings.automod_max_lines_amount) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "max-mentions-opt":
          this.mentionsType = this.mentionsOpt ? this.mentionsOpt.value : "disabled";
          if (this.mentionsType !== this.settings.automod_max_mentions_type) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "max-mentions-int":
          this.mentionsStrikes = this.mentionsStrikes && parseInt(this.mentionsStrikes) ? parseInt(this.mentionsStrikes) : null;
          if (this.mentionsStrikes !== this.settings.automod_max_mentions) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "max-mentions-amount":
          this.mentionsAmount = this.mentionsAmount && parseInt(this.mentionsAmount) ? parseInt(this.mentionsAmount) : 2;
          if (this.mentionsAmount !== this.settings.automod_max_mentions_amount) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "caps-opt":
          this.capsType = this.capsOpt ? this.capsOpt.value : "disabled";
          if (this.capsType !== this.settings.automod_caps_type) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "caps-int":
          this.capsStrikes = this.capsStrikes && parseInt(this.capsStrikes) ? parseInt(this.capsStrikes) : null;
          if (this.capsStrikes !== this.settings.automod_caps) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "spoilers-opt":
          this.spoilersType = this.spoilersOpt ? this.spoilersOpt.value : "disabled";
          if (this.spoilersType !== this.settings.automod_spoilers_type) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "spoilers-int":
          this.spoilersStrikes = this.spoilersStrikes && parseInt(this.spoilersStrikes) ? parseInt(this.spoilersStrikes) : null;
          if (this.spoilersStrikes !== this.settings.automod_spoilers) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "images-opt":
          this.imagesType = this.imagesOpt ? this.imagesOpt.value : "disabled";
          if (this.imagesType !== this.settings.automod_images_type) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "images-int":
          this.imagesStrikes = this.imagesStrikes && parseInt(this.imagesStrikes) ? parseInt(this.imagesStrikes) : null;
          if (this.imagesStrikes !== this.settings.automod_images) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "emojis-opt":
          this.emojisType = this.emojisOpt ? this.emojisOpt.value : "disabled";
          if (this.emojisType !== this.settings.automod_emojis_type) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "emojis-int":
          this.emojisStrikes = this.emojisStrikes && parseInt(this.emojisStrikes) ? parseInt(this.emojisStrikes) : null;
          if (this.emojisStrikes !== this.settings.automod_emojis) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "dehoist-opt":
          this.dehoistType = this.dehoistOpt ? this.dehoistOpt.value : "disabled";
          if (this.dehoistType !== this.settings.automod_dehoist) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "age-int":
          this.ageStrikes = this.ageStrikes && parseInt(this.ageStrikes) ? parseInt(this.ageStrikes) : null;
          if (this.ageStrikes !== this.settings.automod_age_amount) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "age-opt":
          this.ageType = this.ageOpt ? this.ageOpt.value : "disabled";
          if (this.ageType !== this.settings.automod_age_type) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "role-opt":
          this.roleType = this.roleOpt.map(role => role.value);
          if (this.compareArray(this.settings.ignored_roles, this.roleType)) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "channel-opt":
          this.channelType = this.channelOpt.map(channel => channel.value);
          if (this.compareArray(this.settings.ignored_channels, this.channelType)) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        default:
          console.error(`${field} is not a valid settings field.`);
      }
      this.updateBar();
    },
    updateBar: function () {
      const arrayOfChanges = this.arraify(this.changes);

      if (arrayOfChanges.some(c => c === true)) {
        this.confirm = true;
      } else {
        this.confirm = false;
      }
    },
    discard: function () {
      this.init();
      this.changes = {};
      this.updateBar();
    },
    compareArray: function (base, array) {
      var arrayToBase = false;
      var baseToArray = false;
      if (base.length !== array.length) return true;
      for (const item of array) {
        if (!base.includes(item)) {
          arrayToBase = true;
        }
      }
      for (const baseItem of base) {
        if (!array.includes(baseItem)) {
          baseToArray = true;
        }
      }
      if (arrayToBase || baseToArray) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.fetchGuildData();
  }
}
</script>

<style scoped>
.automod-type {
  float: left;
  width: 39%
}

.automod-strikes {
  float: right;
  width: 60%
}

.automod-strikes-second {
  width: 18%;
  margin-left: 1%
}

.automod-strikes-third {
  float: right;
  width: 41%
}

@media only screen and (max-width: 970px) {
  .automod-type, .automod-strikes-second, .automod-strikes-third, .automod-strikes {
    float: none;
    width: 100%;
    margin-top: 1em;
    margin-left: 0;
  }
}
</style>